<template>
  <div id="app" > 
    <div id="app-wrap" v-if="this.$route.path != '/admin-panel'">
      <Navigation/>
      <div class="container">
        <keep-alive v-if="$route.name == 'catalog-page' || $route.name == 'wine-info-page'">
          <router-view :key="$route.path"/> 
        </keep-alive>
        <router-view v-else :key="$route.path"/> 
      </div> 

      <!-- Cookie banner -->
      <cookie-law theme="blood-orange" style="width: 100%; background-color: #b33b3b; color: white;">
        
        <div class="popup-wrap" slot-scope="props">
          <div class="popup-message" slot="message">Þessi síða notar vafrakökur til að greina notkun og bæta virkni vefsíðunnar.</div>
          <div>
            <button class="popup-button popup-agree" @click="props.accept(); /*engageGoogleAnalytics();*/"><span>Samþykkja</span></button>
            <!-- <button class="popup-button popup-disagree" @click="props.accept(); stopGoogleAnalytics();"><span>Nei takk</span></button> -->
          </div>
        </div>
      </cookie-law>

      <AppFooter/>
    </div>

    <div v-else>
      <router-view/> 
    </div>
  </div>
  
</template>

<script>
import Navigation from './components/Navigation.vue'
import AppFooter from './components/AppFooter.vue'
import CookieLaw from 'vue-cookie-law'
export default {
  components: {
    Navigation,
    AppFooter,
    CookieLaw
  },
  methods: {
    stopGoogleAnalytics() {
      /* this.$ga.disable(); */
      this.$gtag('consent', 'default', {
        'analytics_storage': 'denied'
      })
    },
    engageGoogleAnalytics() {
      /* this.$ga.enable(); */
      this.gtag('consent', 'default', {
        'analytics_storage': 'granted'
      })
    }
  }, 
  watch: {
    /* test routing */
    /* $route () {
      this.gtag('config', 'G-CZMEV6S49S', {
            'page_title' : this.$route.name,
            'page_path': this.$route.path
      });
    }, */
    '$route.path': function() {
      if (this.$route.path == "/") {
        var element = document.getElementById("app-wrap")
        element.style.backgroundImage = 'url(' + require('./assets/background-image-opacity.png') + ')'
        element.style.backgroundAttachment = 'fixed'
        element.style.backgroundPosition = 'center'
        element.style.backgroundRepeat = 'no-repeat'
        element.style.backgroundSize = 'cover'
      } else {
        document.getElementById("app-wrap").style.backgroundImage = ''
      }
    }
  },
  mounted: function() {
    /* this.$ga.enable(); */
    if (this.$route.path == "/") {
      var element = document.getElementById("app-wrap")
      element.style.backgroundImage = 'url(' + require('./assets/background-image-opacity.png') + ')'
      element.style.backgroundAttachment = 'fixed'
      element.style.backgroundPosition = 'center'
      element.style.backgroundRepeat = 'no-repeat'
      element.style.backgroundSize = 'cover'
    } else {
      document.getElementById("app-wrap").style.backgroundImage = ''
    }
  }
}
</script>

<style>
/*@import url('https://fonts.googleapis.com/css?family=Oswald&display=swap');*/

@font-face {
  font-family: 'Oswald';
  src: url('~@/assets/Oswald-VariableFont_wght.ttf') format('truetype'),
    url('~@/assets/oswald-variablefont_wght-webfont.woff') format('woff'),
    url('~@/assets/oswald-variablefont_wght-webfont.woff2') format('woff2');
}
/* Disable horizontal scrolling on mobile */

body {
  position: relative;
  margin: 0 !important;
}
#app {
  font-family: 'Oswald', 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  width: 100vw;
  max-width: 100%;
  background-color: #f0f0f0;
  -webkit-text-size-adjust: 100%
}

.container {
  margin: 0 auto;
  min-height: calc(100vh - 350px);
}
input {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
}
.cookie-button {
  background-color: #b33b3b;
  border: none;
  color: white;
  font-size: 1em;
  margin-right: 20px;
  padding: 5px;
  cursor: pointer;
  font-family: 'Oswald', 'Avenir', Helvetica, Arial, sans-serif;
}
@media only screen and (max-width: 768px) {
  .container{
    width:90%;
  }
  html, body {
    overflow-x: hidden;
  }
  .popup-message {
    width: 100%;
    margin-bottom: 20px;
  }
  .popup-button { 

  }
}
@media only screen and (min-width: 769px) {
  .container{
    width:90%;
  }
}
@media only screen and (min-width: 1200px) {
  .container{
    width:60%;
  }
}

.popup-wrap {
  display:flex; 
  justify-content: center; 
  flex-wrap: wrap;
  width: 100%; 
}
.popup-message {
  line-height: 38px;
  margin-right: 20px;
  font-size: 20px
}
.popup-button {
  font-weight: bold; 
  border-radius:5px;
  outline: none;
  border: none;
  cursor: pointer;
}
.popup-agree {
  background-color: white; 
  color: #b33b3b; 
  padding: 10px 20px;
}
.popup-disagree {
  background-color: #b33b3b; 
  color: white; 
  margin-left: 5px;
  margin: 10px 20px;
}
</style>
